import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.css']
})
export class ProductDetailComponent implements OnInit {
  
  refresh : boolean = false;
  componentId : string;
  @Input() set setComponentId(id:string){
    this.componentId = id;
    this.refresh = true;
  }

  constructor() { }

  ngOnInit() {
  }

  bread() {

  }

}
